import React, { Component, createRef } from 'react'
import { findDOMNode } from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { /* DragSource, */ DropTarget } from 'react-dnd'
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  withStyles,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Tooltip,
} from '@material-ui/core'
import {
  ExpandMore,
  // DragIndicator,
  Group,
  MoreVert,
  Delete,
  ArrowUpward,
  ArrowDownward,
} from '@material-ui/icons'
import classNames from 'classnames'
import ButtonAdd from './ButtonAdd'
import {
  changeStageName,
  expandFunnelStage,
  addEventGoalToCampaign,
  addOrEditEventGoal,
  toggleTaskModal,
  moveStage,
  deleteStage,
  clickContactCount,
  addPlaceholderTask,
} from 'actions/campaign/addOrEdit'
import { createOrUpdateCampaign } from 'actions/campaign'
import EventGoals from './EventsGoals'
import Tasks from './Tasks'
// import { flow } from 'lodash'
import styles from './styles'
import language from 'utils/vast-languagepack'
import { openSnackbar } from 'actions/view'
import GroupDialog from 'components/GroupDialog'

class StageComponent extends Component {
  constructor(props) {
    super(props)
    this.myRef = createRef()
    this.state = {
      typing: false,
      anchorEl: null,
      name: props?.stage?.name,
    }
  }

  // state = {
  //   typing: false,
  //   anchorEl: null,
  // }

  handleChange = value => {
    clearTimeout(this.timeout)
    this.setState({ typing: true, name: value })
    this.timeout = setTimeout(() => {
      this.props.changeStageName({
        name: value,
        index: this.props.idx,
      })
      this.props.createOrUpdateCampaign()
      this.setState({ typing: false })
    }, 500)
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  scrollToMyRef = () => window.scrollTo(0, this.myRef.current.offsetTop)

  render() {
    const {
      idx,
      stage,
      funnelStageExpanded,
      classes,
      // stages,
      expandFunnelStage,
      isOver,
      connectDropTarget,
      // connectDragSource,
      deleteStage,
      createOrUpdateCampaign,
      // didDrop,
      taskIDsInAllStages,
      clickContactCount,
      stageId,
      isDragging,
      taskIDsInCampaign,
      openSnackbar,
      // addPlaceholderTask,
      isFirstStage,
      isLastStage,
      moveStage,
    } = this.props
    const { anchorEl } = this.state

    this.confirmDelete = function (d) {
      return window.confirm(d)
    }

    const comp = (
      <div
        ref={this.myRef}
        style={
          isDragging
            ? {
                transform: 'translate(0, 0)',
                border: '3px solid #026fd9',
                borderRadius: 35,
                padding: 4,
                margin: 4,
              }
            : { transform: 'translate(0, 0)' }
        }
      >
        <ExpansionPanel
          onChange={(event, bool) => {
            if (bool) {
              return Promise.resolve(expandFunnelStage(idx)).then(() => {
                return this.scrollToMyRef()
              })
            } else {
              return expandFunnelStage(null)
            }
          }}
          expanded={funnelStageExpanded === idx}
          classes={{
            root: classes.expansionPanelRoot,
            expanded: classes.expansionPanelExpanded,
          }}
        >
          {/* <div
						style={{
							position: 'absolute',
							left: 14,
							width: 2,
							height: 'calc(100% - 50px)',
							backgroundColor: '#034c94',
							display: stages.length === idx + 1 ? 'none' : 'block',
						}}
					/> */}
          <ExpansionPanelSummary
            classes={{
              root: classes.summaryRoot,
              expanded: classes.summaryExpanded,
              content: classes.content,
              expandIcon: classNames(
                classes[`expandIcon${idx}`],
                classes.expandIconMore,
                funnelStageExpanded === idx ? classes.expandIconExpanded : null,
              ),
            }}
            IconButtonProps={{ disableRipple: true }}
            expandIcon={<ExpandMore style={{ color: '#fff' }} />}
          >
            <div
              style={{
                width: '100%',
                // paddingLeft: 48,
                paddingLeft: 0,
                paddingRight: 0,
              }}
            >
              {/* <div
								className={classNames(
									classes.numberIcon,
									classes[`backgroundColor${idx}`],
									classes.backgroundColorMore,
									funnelStageExpanded === idx
										? classes.numberIconExpanded
										: classes.numberIconCollapsed,
								)}
							>
								{parseInt(idx) + 1}
							</div> */}
              <div
                style={{
                  borderStyle: 'solid',
                  borderWidth: 2,
                  borderBottomWidth: 0,
                  borderColor: isOver ? '#003261' : 'transparent',
                }}
                className={classNames(
                  classes.background,
                  classes[`backgroundColor${idx}`],
                  classes[`backgroundWidth${idx}`],
                  classes.backgroundColorMore,
                  classes.backgroundWidthMore,
                  funnelStageExpanded === idx
                    ? classes.backgroundExpanded
                    : classes.backgroundCollapsed,
                )}
              >
                {/* <DragIndicator
									style={{
										position: 'absolute',
										left: 5,
										top: funnelStageExpanded === idx ? 22 : 10,
										fill: 'rgba(255, 255, 255, 0.5)',
										cursor: 'grab',
									}}
								/> */}
                <input
                  disabled={
                    this.props.status === 'L' || this.props.status === 'C'
                  }
                  className={classNames(
                    classes.heading,
                    funnelStageExpanded === idx
                      ? classes.headingExpanded
                      : null,
                  )}
                  value={this.state.name}
                  placeholder={language.campaign.add.stageName}
                  onClick={e => e.stopPropagation()}
                  onChange={e => {
                    this.handleChange(e?.target?.value)
                  }}
                />
                <IconButton
                  disabled={
                    this.props.status === 'L' || this.props.status === 'C'
                  }
                  style={{
                    position: 'absolute',
                    right: 103,
                    top: funnelStageExpanded === idx ? 14 : 6,
                    color: '#fff',
                    padding: 6,
                  }}
                  aria-owns={anchorEl ? `stageMenu${idx}` : undefined}
                  aria-haspopup="true"
                  onClick={e => {
                    e.stopPropagation()
                    this.handleClick(e)
                  }}
                  disableRipple
                  disableTouchRipple
                >
                  <MoreVert />
                </IconButton>
                <Menu
                  id={`stageMenu${idx}`}
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={e => {
                    e.stopPropagation()
                    this.handleClose()
                  }}
                >
                  <MenuItem
                    disabled={isFirstStage}
                    onClick={e => {
                      e.stopPropagation()
                      this.handleClose()
                      Promise.resolve(moveStage(idx, idx - 1))
                        .then(() => createOrUpdateCampaign())
                    }}
                  >
                    <ListItemIcon className={classes.icon}>
                      <ArrowUpward />
                    </ListItemIcon>
                    <ListItemText
                      classes={{
                        primary: classes.primary,
                        root: classes.listItemTextRoot,
                      }}
                      primary="Move Stage Up"
                    />
                  </MenuItem>
                  <MenuItem
                    disabled={isLastStage}
                    onClick={e => {
                      e.stopPropagation()
                      this.handleClose()
                      Promise.resolve(moveStage(idx, idx + 1))
                        .then(() => createOrUpdateCampaign())
                    }}
                  >
                    <ListItemIcon className={classes.icon}>
                      <ArrowDownward />
                    </ListItemIcon>
                    <ListItemText
                      classes={{
                        primary: classes.primary,
                        root: classes.listItemTextRoot,
                      }}
                      primary="Move Stage Down"
                    />
                  </MenuItem>
                  <MenuItem
                    onClick={e => {
                      e.stopPropagation()
                      this.handleClose()
                      if (stage?.tasks?.length) {
                        openSnackbar({
                          type: 'error',
                          message:
                            'Remove Tasks from the stage if you would like to delete this stage.',
                        })
                      } else {
                        this.confirmDelete(
                          `${language.campaign.add.campaignDeleteWarning} ${stage.name}${language.campaign.add.campaignDeleteWarning2}`,
                        ) &&
                          Promise.resolve(deleteStage(idx)).then(() =>
                            createOrUpdateCampaign(),
                          )
                      }
                    }}
                  >
                    <ListItemIcon className={classes.icon}>
                      <Delete />
                    </ListItemIcon>
                    <ListItemText
                      classes={{
                        primary: classes.primary,
                        root: classes.listItemTextRoot,
                      }}
                      primary={language.campaign.add.deleteStage}
                    />
                  </MenuItem>
                </Menu>
                <div
                  style={{
                    position: 'absolute',
                    color: '#fff',
                    right: 50,
                    top: funnelStageExpanded === idx ? 24 : 15,
                    fontSize: 14,
                    fontWeight: 'bold',
                  }}
                >
                  <Tooltip
                    title={`There ${
                      stage.current_contact_count === 1 ? 'is' : 'are'
                    } ${stage.current_contact_count || 0} contact${
                      stage.current_contact_count === 1 ? '' : 's'
                    } currently in this stage. ${
                      stage.current_contact_count
                        ? 'Click here to view details.'
                        : ''
                    }`}
                  >
                    <div
                      onClick={e => {
                        if (stage.current_contact_count) {
                          e.stopPropagation()
                          clickContactCount({
                            id: stageId,
                            name: stage.name,
                          })
                        }
                      }}
                      style={{ position: 'relative', cursor: 'pointer' }}
                    >
                      <Group
                        style={{
                          position: 'absolute',
                          left: '-30px',
                          top: '-3px',
                        }}
                      />
                      {stage.current_contact_count
                        ? `${stage.current_contact_count}`
                        : '0'}
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails classes={{ root: classes.detailsRoot }}>
            <div
              style={{
                backgroundColor: '#fff',
                borderBottomLeftRadius: 35,
                borderBottomRightRadius: 35,
                width: '100%',
                borderStyle: 'solid',
                borderWidth: 2,
                borderTopWidth: 0,
                borderColor: isOver ? '#003261' : 'transparent',
              }}
            >
              <EventGoals
                taskIDsInAllStages={taskIDsInAllStages}
                stageIdx={idx}
                taskIDsInCampaign={taskIDsInCampaign}
              />
              <div style={{ height: 1, backgroundColor: '#bababa' }} />
              <Tasks
                campaignID={this.props.campaignID}
                stageId={this.props.stageId}
                stageIdx={idx}
              />
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    )

    // return comp

    return /*  connectDragSource( */ connectDropTarget(comp) /* ) */
  }
}

const Stage =
  /* flow( */
  // DragSource(
  // 	'stage',
  // 	{
  // 		beginDrag(props) {
  // 			props.expandFunnelStage(null)
  // 			return {
  // 				id: props.id,
  // 				index: props.index,
  // 				stage: props.stage,
  // 				classes: props.classes,
  // 				idx: props.idx,
  // 			}
  // 			// return props
  // 			// this was how generating a mobile preview worked, but it errors out on desktop
  // 		},
  // 	},
  // 	(connect, monitor) => ({
  // 		connectDragSource: connect.dragSource(),
  // 		isDragging: monitor.isDragging(),
  // 	}),
  // ),
  DropTarget(
    // props => props.accepts,
    ['stage', 'taskType', 'eventgoaloption'],
    {
      drop(props, monitor) {
        props.expandFunnelStage(props.index)
        const itemType = monitor.getItemType()
        if (itemType === 'taskType' || itemType === 'eventgoaloption') {
          props.onDrop(monitor.getItem())
        }
        if (itemType === 'stage') {
          props.createOrUpdateCampaign()
        }
      },
      hover(props, monitor, component) {
        const itemType = monitor.getItemType()
        if (itemType === 'stage') {
          const dragIndex = monitor.getItem().index
          const hoverIndex = props.index
          if (dragIndex === hoverIndex) {
            return
          }
          const hoverBoundingRect =
            findDOMNode(component).getBoundingClientRect()
          const hoverMiddleY =
            (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
          const clientOffset = monitor.getClientOffset()
          const hoverClientY = clientOffset.y - hoverBoundingRect.top
          if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return
          }
          if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return
          }
          Promise.resolve(props.moveStage(dragIndex, hoverIndex)) /* .then(() =>
            props.createOrUpdateCampaign(),
          ) */
          monitor.getItem().index = hoverIndex
        }
      },
    },
    (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      didDrop: monitor.didDrop(),
    }),
  )(
    // )
    StageComponent,
  )

const ConnectedGroupDialog = connect(
  state => ({
    eventgoaloptions: state.data.eventgoaloption,
    index: state.campaign.addOrEdit.funnelStageExpanded,
    newEventGoal: state.campaign.addOrEdit.newEventGoal,
  }),
  dispatch =>
    bindActionCreators(
      { addEventGoalToCampaign, createOrUpdateCampaign },
      dispatch,
    ),
)(
  ({
    addEventGoalToCampaign,
    index,
    eventgoaloptions,
    newEventGoal,
    createOrUpdateCampaign,
  }) => (
    <GroupDialog
      stageIdx={index}
      thenFunc={payload =>
        Promise.resolve(
          addEventGoalToCampaign({
            event_goal: {
              event_type: eventgoaloptions?.[newEventGoal.id]?.event_type,
              entity: payload?.id,
            },
            index,
            editIdx: newEventGoal.editIdx,
          }),
        ).then(() => createOrUpdateCampaign())
      }
    />
  ),
)

export default connect(
  (state, { campaignID }) => ({
    stages: state.campaign.addOrEdit.campaign.stages,
    funnelStageExpanded: state.campaign.addOrEdit.funnelStageExpanded,
    status: state.campaign.addOrEdit.campaign.status,
    taskIDsInCalendar: state.campaign.addOrEdit.campaign.calendar,
  }),
  dispatch =>
    bindActionCreators(
      {
        changeStageName,
        expandFunnelStage,
        addEventGoalToCampaign,
        addOrEditEventGoal,
        toggleTaskModal,
        createOrUpdateCampaign,
        moveStage,
        deleteStage,
        clickContactCount,
        openSnackbar,
        addPlaceholderTask,
      },
      dispatch,
    ),
)(
  withStyles(styles)(
    ({
      stages,
      classes,
      changeStageName,
      funnelStageExpanded,
      expandFunnelStage,
      addEventGoalToCampaign,
      addOrEditEventGoal,
      toggleTaskModal,
      createOrUpdateCampaign,
      moveStage,
      deleteStage,
      campaignID,
      status,
      clickContactCount,
      mobile,
      taskIDsInCalendar,
      openSnackbar,
      addPlaceholderTask,
    }) => {
      let taskIDsInAllStages = []
      if (stages.length) {
        stages.forEach(stage => {
          stage.tasks.forEach(task => {
            taskIDsInAllStages.push(task)
          })
        })
      }

      return (
        <div
        // style={mobile ? { width: 'calc(100vw - 24px)' } : null}
        >
          {stages.map((stage, idx) => {
            return (
              <Stage
                key={`stage${stage.id || idx}`}
                id={`stage${stage.id || idx}`}
                stageId={stage.id || null}
                campaignID={campaignID}
                index={idx}
                isFirstStage={idx === 0}
                isLastStage={idx === stages.length - 1}
                onDrop={item => {
                  console.log('item:')
                  console.log(item)

                  return item.eventgoaloption
                    ? (item.eventgoaloption.entity_id_type &&
                        item.eventgoaloption.entity_id_type !== '"-1"') ||
                      item.eventgoaloption.subentity_id_type ||
                      item.eventgoaloption.subentity_value
                      ? addOrEditEventGoal({
                          stage: idx,
                          ...item.eventgoaloption,
                        })
                      : Promise.resolve(
                          addEventGoalToCampaign({
                            event_goal: {
                              event_type: item.eventgoaloption.event_type,
                              entity: '0',
                            },
                            index: idx,
                          }),
                        ).then(() => createOrUpdateCampaign())
                    : // ? addOrEditEventGoal({
                    //     stage: idx,
                    //     ...item.eventgoaloption,
                    //   })
                    item.taskType
                    ? /* toggleTaskModal({
												taskTypeID: item.taskType.id,
												stageIdx: idx,
										  }) */
                      addPlaceholderTask(
                        {
                          taskTypeID: item.taskType.id,
                          // name: item.taskType.display_name,
                          task_type_id: item.taskType.id,
                        },
                        idx,
                        item.taskType.display_name,
                      )
                    : console.log(item)
                }}
                // accepts={['funnel']}
                idx={idx}
                stage={stage}
                funnelStageExpanded={funnelStageExpanded}
                classes={classes}
                stages={stages}
                expandFunnelStage={expandFunnelStage}
                changeStageName={changeStageName}
                createOrUpdateCampaign={createOrUpdateCampaign}
                moveStage={moveStage}
                deleteStage={deleteStage}
                status={status}
                taskIDsInAllStages={taskIDsInAllStages}
                clickContactCount={clickContactCount}
                openSnackbar={openSnackbar}
                taskIDsInCampaign={taskIDsInAllStages.concat(taskIDsInCalendar)}
                // addPlaceholderTask={addPlaceholderTask}
              />
            )
          })}
          <ButtonAdd
            classNames={classNames(
              classes[`backgroundWidth${stages.length}`],
              classes.backgroundWidthMore,
              classes.buttonAdd,
            )}
            typographyClassname={classes.buttonAddTypography}
          />
          <ConnectedGroupDialog />
        </div>
      )
    },
  ),
)
